import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

// 이미지 import
import headerSectionMobile from "../../../assets/images/Landing_AutoDisplay/headersectionmobile.png";
import introIcon1 from "../../../assets/images/Landing_AutoDisplay/introicon1.png";
import introIcon2 from "../../../assets/images/Landing_AutoDisplay/introicon2.png";
import featureSection1 from "../../../assets/images/Landing_AutoDisplay/featuresection1.png";
import featureSection2 from "../../../assets/images/Landing_AutoDisplay/featuresection2.png";
import featureSection3 from "../../../assets/images/Landing_AutoDisplay/featuresection3.png";
import featureSection4 from "../../../assets/images/Landing_AutoDisplay/featuresection4.png";
import serviceLogo from "../../../assets/images/Landing_AutoDisplay/servicelogo.png";
import useCaseSection1 from "../../../assets/images/Landing_AutoDisplay/usecasesection1.png";
import useCaseSection2 from "../../../assets/images/Landing_AutoDisplay/usecasesection2.png";
import useCaseSection3 from "../../../assets/images/Landing_AutoDisplay/usecasesection3.png";
import introSection from "../../../assets/images/Landing_AutoDisplay/introsection.png";
import allowDown from "../../../assets/images/Landing_AutoDisplay/allow_down.png";

// Mobile Container
const MobileContainer = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  background: white;
  overflow-x: hidden;
  position: relative;
`;

// Status Bar
const StatusBar = styled.div`
  width: 375px;
  height: 44px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  background: transparent;
`;

const StatusBarContent = styled.div`
  width: 79.99px;
  height: 13.6px;
  position: absolute;
  right: 20px;
  top: 15px;
`;

const BatteryBorder = styled.div`
  width: 26.4px;
  height: 13.6px;
  position: absolute;
  right: 0;
  top: 0;
  opacity: 0.35;
  border-radius: 3.2px;
  border: 1.2px white solid;
`;

const BatteryCap = styled.div`
  width: 1.59px;
  height: 4.8px;
  position: absolute;
  right: -2px;
  top: 4.4px;
  opacity: 0.4;
  background: white;
`;

const BatteryCapacity = styled.div`
  width: 21.6px;
  height: 8.8px;
  position: absolute;
  right: 2.4px;
  top: 2.4px;
  background: white;
  border-radius: 1.6px;
`;

const TimeDisplay = styled.div`
  width: 54px;
  height: 21px;
  position: absolute;
  left: 33px;
  top: 12px;
  color: white;
  font-size: 14px;
  font-family: Pretendard;
  font-weight: 600;
`;

// Hero Section
const HeroSection = styled.section`
  width: 100%;
  height: 762px;
  position: relative;
  background-image: url(${headerSectionMobile});
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 20px;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1;
  }
`;

const HeroContent = styled.div`
  width: 335px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
  color: white;
  position: relative;
  z-index: 2;
  margin-top: 120px;
`;

const LogoSection = styled.div`
  display: flex;
  align-items: left;
  gap: 4px;
  margin-bottom: 32px;
  position: absolute;
  top: 64px;
  left: 20px;
  z-index: 3;
`;

const LogoImage = styled.img`
  width: 26px;
  height: 26px;
  align-self: center;
`;

const LogoText = styled.span`
  color: white;
  font-size: 24px;
  font-family: Pretendard;
  font-weight: 700;
`;

const ScrollIndicator = styled.div`
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 3;

  @keyframes bounce {
    0%,
    20%,
    50%,
    80%,
    100% {
      transform: translateX(-50%) translateY(0);
    }
    40% {
      transform: translateX(-50%) translateY(-10px);
    }
    60% {
      transform: translateX(-50%) translateY(-5px);
    }
  }

  animation: bounce 2s infinite;

  &:hover {
    animation: none;
    transform: translateX(-50%) translateY(8px);
  }
`;

const ScrollArrow = styled.img`
  width: 42px;
  height: 12px;
  opacity: 0.8;
  transition: opacity 0.3s ease;

  ${ScrollIndicator}:hover & {
    opacity: 1;
  }
`;

const HeroTitle = styled.h1`
  color: white;
  font-size: 32px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 41.6px;
  margin: 0;
  text-align: center;
`;

const HeroSubtitle = styled.p`
  color: #ebebeb;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 500;
  line-height: 22.4px;
  margin: 0;
  text-align: center;
`;

const HeroButton = styled.button`
  height: 44px;
  padding: 8px 32px;
  background: #256ef4;
  border: none;
  border-radius: 22px;
  color: white;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 700;
  cursor: pointer;
  margin-top: 20px;
  transition: all 0.3s ease;

  &:hover {
    background: #1e5dc7;
    transform: translateY(-2px);
  }
`;

// Feature Section
const FeatureSection = styled.section`
  width: 100%;
  padding: 92px 20px 0px 20px;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
`;

const FeatureHeader = styled.div`
  width: 100%;
  max-width: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  text-align: center;
`;

const FeatureTitle = styled.h2`
  color: #1f1f1f;
  font-size: 30px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 42px;
  margin: 0;
`;

const FeatureSubtitle = styled.p`
  color: #666666;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 24.8px;
  margin: 0;
`;

// Feature Items
const FeatureItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  max-width: 335px;
`;

const FeatureItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
`;

const FeatureIcon = styled.img`
  width: 60px;
  height: 60px;
  object-fit: contain;
`;

const FeatureItemTitle = styled.h3`
  color: #1f1f1f;
  font-size: 26px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 40.3px;
  margin: 0;
`;

const FeatureItemDescription = styled.p`
  color: #666666;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 24.8px;
  margin: 0;
`;

// Feature Details Section
const FeatureDetailsSection = styled.section`
  width: 100%;
  padding: 92px 20px;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 80px;
`;

const FeatureDetail = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  gap: 36px;
`;

const FeatureDetailReverse = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  gap: 36px;
`;

const FeatureVisual = styled.div`
  width: 100%;
  max-width: 335px;
  height: 287px;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const FeatureInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 335px;
  text-align: left;
`;

const FeatureBadge = styled.div`
  padding: 0px 0px;
  border-radius: 100px;
  color: #256ef4;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  width: fit-content;
  align-self: flex-start;
`;

const FeatureInfoTitle = styled.h3`
  color: #1f1f1f;
  font-size: 28px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 43.4px;
  margin-bottom: 18px;
`;

const FeatureInfoDescription = styled.p`
  color: #666666;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 24.8px;
  margin: 0;
`;

// Use Cases Section
const UseCasesSection = styled.section`
  width: 100%;
  padding: 92px 20px;
  background: #faf9ff;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const UseCasesHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: left;
`;

const UseCasesBadge = styled.div`
  padding: 8px 24px;
  background: #cfdefc;
  border-radius: 100px;
  color: #1f1f1f;
  font-size: 18px;
  font-family: Pretendard;
  font-weight: 600;
  width: fit-content;
  align-self: flex-start;
  margin-bottom: 8px;
`;

const UseCasesTitle = styled.h2`
  color: #1f1f1f;
  font-size: 30px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 42px;
  margin: 0;
`;

const UseCasesDescription = styled.p`
  color: #525252;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 24.8px;
  margin: 0;
`;

const UseCaseCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const UseCaseCard = styled.div`
  width: 100%;
  height: 386px;
  padding: 36px 32px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 12.85px;
  position: relative;
  overflow: hidden;
  background-image: ${(props) =>
    props.bgImage
      ? `url(${props.bgImage})`
      : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"};
  background-size: cover;
  background-position: center;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.6) 80%
    );
    z-index: 1;
  }

  > * {
    position: relative;
    z-index: 2;
  }
`;

const UseCaseCardTitle = styled.h3`
  color: white;
  font-size: 28px;
  font-family: Pretendard;
  font-weight: 600;
  line-height: 43.4px;
  margin: 0;
  text-align: left;
`;

const UseCaseCardCategory = styled.p`
  color: #f0f0f0;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 24.8px;
  margin: 0;
`;

// CTA Section
const CTASection = styled.section`
  width: 100%;
  position: relative;
  padding: 90px 20px 92px 20px;
`;

const CTABackground = styled.div`
  width: 100%;
  max-width: 335px;
  height: 436px;
  margin: 0 auto;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  background-image: url(${introSection});
  background-size: cover;
  background-position: center;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 2;
  }
`;

const CTAContent = styled.div`
  width: 100%;
  max-width: 279px;
  position: absolute;
  top: 44px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 0px;
  margin-top: 20px;
  letter-spacing: -0.3px;
`;

const CTATitle = styled.h2`
  color: white;
  font-size: 30px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 42px;
  margin: 0;
  text-align: left;
  line-height: 1.55;
  margin-top: 68px;
`;

const CTADescription = styled.p`
  color: #f0f0f0;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 300;
  line-height: 24.8px;
  margin: 0;
  text-align: left;
  letter-spacing: -0.5px;
  line-height: 1.55;
  margin-bottom: 28px;
`;

const CTAButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 32px;
`;

const PrimaryButton = styled.button`
  height: 44px;
  padding: 10px 32px;
  background: white;
  border: none;
  border-radius: 22px;
  color: #1f1f1f;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;

  &:hover {
    background: #f0f0f0;
    transform: translateY(-2px);
  }
`;

const SecondaryButton = styled.button`
  height: 44px;
  padding: 10px 32px;
  background: #256ef4;
  border: none;
  border-radius: 22px;
  color: white;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;

  &:hover {
    background: #1e5dc7;
    transform: translateY(-2px);
  }
`;

// Footer Section
const FooterSection = styled.section`
  width: 100%;
  padding: 64px 20px 48px;
  background: #f6f6f6;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  text-align: left;
`;

const CompanyName = styled.h3`
  color: #1f1f1f;
  font-size: 14px;
  font-family: Pretendard;
  font-weight: 500;
  margin: 0;
`;

const ServiceName = styled.h3`
  color: #1f1f1f;
  font-size: 20px;
  font-family: Pretendard;
  font-weight: 700;
  margin: 0;
`;

const CompanyInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const CompanyInfoText = styled.span`
  color: #323232;
  font-size: 12px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 14.4px;
`;

const Copyright = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 16px;
`;

const CopyrightText = styled.span`
  color: #323232;
  font-size: 12px;
  font-family: Pretendard;
  font-weight: 600;
  line-height: 14.4px;
`;

const PageAutodisplayMobileLanding = () => {
  const navigate = useNavigate();

  const handleScrollToFeatures = () => {
    const element = document.querySelector("#feature-section");
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  return (
    <MobileContainer>
      {/* Hero Section */}
      <HeroSection>
        <StatusBar>
          {/* <TimeDisplay>9:41</TimeDisplay>
                    <StatusBarContent>
                        <BatteryBorder />
                        <BatteryCap />
                        <BatteryCapacity />
                    </StatusBarContent> */}
        </StatusBar>

        <LogoSection>
          <LogoImage src={serviceLogo} alt="서비스 로고" />
          <LogoText>AutoDisplay</LogoText>
        </LogoSection>

        <HeroContent>
          <HeroTitle>
            현장의 실시간
            <br />
            정보를 위한
            <br />
            AI 콘텐츠 생성 서비스
          </HeroTitle>
          <HeroSubtitle>
            다양한 정보, 이제는 화면으로 바로 연결하세요
          </HeroSubtitle>
          <HeroButton onClick={() => navigate("/Login")}>
            지금 바로 시작하기
          </HeroButton>
        </HeroContent>

        <ScrollIndicator onClick={handleScrollToFeatures}>
          <ScrollArrow src={allowDown} alt="아래로 스크롤" />
        </ScrollIndicator>
      </HeroSection>

      {/* Feature Section */}
      <FeatureSection id="feature-section">
        <FeatureHeader>
          <FeatureTitle>
            한 번에 완성하는
            <br />
            맞춤 디스플레이 콘텐츠
          </FeatureTitle>
          <FeatureSubtitle>
            공공 안내부터 실시간 데이터까지
            <br />
            현장에서 필요한 콘텐츠를
            <br />
            AI가 구성해드립니다.
          </FeatureSubtitle>
        </FeatureHeader>

        <FeatureItems>
          <FeatureItem>
            <FeatureIcon src={introIcon1} alt="문서기반 콘텐츠 자동화 아이콘" />
            <FeatureItemTitle>문서기반 콘텐츠 자동화</FeatureItemTitle>
            <FeatureItemDescription>
              텍스트나 파일만 넣으면, 안내문 형식으로
              <br />
              보기 좋게 정리해서 깔끔한 디스플레이
              <br />
              콘텐츠로 AI가 만들어 드려요
            </FeatureItemDescription>
          </FeatureItem>

          <FeatureItem>
            <FeatureIcon src={introIcon2} alt="실시간 정보 디스플레이 아이콘" />
            <FeatureItemTitle>실시간 정보 디스플레이</FeatureItemTitle>
            <FeatureItemDescription>
              날씨, 교통, 공공 데이터 등 변화하는 정보를
              <br />
              자동으로 연결해 쉽고 빠르게 디스플레이에
              <br />
              보여드려요
            </FeatureItemDescription>
          </FeatureItem>
        </FeatureItems>
      </FeatureSection>

      {/* Feature Details Section */}
      <FeatureDetailsSection>
        <FeatureDetail>
          <FeatureVisual>
            <img src={featureSection1} alt="콘텐츠 생성 자동화" />
          </FeatureVisual>
          <FeatureInfo>
            <FeatureBadge>콘텐츠 생성 자동화</FeatureBadge>
            <FeatureInfoTitle>
              혼자서도 가능한
              <br />
              노코드 콘텐츠 생성
            </FeatureInfoTitle>
            <FeatureInfoDescription>
              복잡한 협업 과정 없이도
              <br />
              AI가 모든 단계를 자동으로 처리합니다.
            </FeatureInfoDescription>
          </FeatureInfo>
        </FeatureDetail>

        <FeatureDetailReverse>
          <FeatureVisual>
            <img src={featureSection2} alt="간편 게시 & 관리" />
          </FeatureVisual>
          <FeatureInfo>
            <FeatureBadge>간편 게시 & 관리</FeatureBadge>
            <FeatureInfoTitle>
              원하는 디스플레이에
              <br />
              코드만 입력하면 게시 완료
            </FeatureInfoTitle>
            <FeatureInfoDescription>
              코드를 복사해서 원하는 디스플레이에
              <br />
              입력하기만 하면 키오스크, 대시보드 등
              <br />
              쉽게 게시가 가능합니다.
            </FeatureInfoDescription>
          </FeatureInfo>
        </FeatureDetailReverse>

        <FeatureDetail>
          <FeatureVisual>
            <img src={featureSection3} alt="유연한 데이터 연동" />
          </FeatureVisual>
          <FeatureInfo>
            <FeatureBadge>유연한 데이터 연동</FeatureBadge>
            <FeatureInfoTitle>
              원하는 데이터만 선택하면
              <br />
              AI가 바로 연결
            </FeatureInfoTitle>
            <FeatureInfoDescription>
              날씨 정보, 교통 정보 등 공공 API까지
              <br />
              원하는 데이터를 선택하기만 하면
              <br />
              AI가 자동 연동합니다.
            </FeatureInfoDescription>
          </FeatureInfo>
        </FeatureDetail>

        <FeatureDetailReverse>
          <FeatureVisual>
            <img src={featureSection4} alt="내부 데이터 연동" />
          </FeatureVisual>
          <FeatureInfo>
            <FeatureBadge>내부 데이터 연동</FeatureBadge>
            <FeatureInfoTitle>
              현장 맞춤 데이터
              <br />
              커스터마이징
            </FeatureInfoTitle>
            <FeatureInfoDescription>
              각 부서와 직원들이 자주 확인해야하는
              <br />
              센서정보, 운영 데이터, 작업 지표 등 내부 정보를
              <br />
              디스플레이에 맞춤 구성해 보여드려요
            </FeatureInfoDescription>
          </FeatureInfo>
        </FeatureDetailReverse>
      </FeatureDetailsSection>

      {/* Use Cases Section */}
      <UseCasesSection>
        <UseCasesHeader>
          <UseCasesBadge>Autodisplay 활용 사례</UseCasesBadge>
          <UseCasesTitle>
            현장에 필요한 정보,
            <br />
            이렇게 보여주세요
          </UseCasesTitle>
          <UseCasesDescription>
            고객사의 업무 흐름에 AI 콘텐츠 자동화가 더해지면
            <br />
            어떤 변화가 생길까요?
          </UseCasesDescription>
        </UseCasesHeader>

        <UseCaseCards>
          <UseCaseCard bgImage={useCaseSection1}>
            <UseCaseCardTitle>
              문서만 넣으면
              <br />
              디스플레이 콘텐츠 완성
            </UseCaseCardTitle>
            <UseCaseCardCategory>공무원 | 공문서 콘텐츠</UseCaseCardCategory>
          </UseCaseCard>

          <UseCaseCard bgImage={useCaseSection2}>
            <UseCaseCardTitle>
              중요한 소식도
              <br />
              놓치지 않게 게시
            </UseCaseCardTitle>
            <UseCaseCardCategory>기업 | 사내 시스템 공지</UseCaseCardCategory>
          </UseCaseCard>

          <UseCaseCard bgImage={useCaseSection3}>
            <UseCaseCardTitle>
              실시간으로 변하는
              <br />
              현장 상황도 지연 없이
            </UseCaseCardTitle>
            <UseCaseCardCategory>
              공장 | 생산 설비 가동 현황
            </UseCaseCardCategory>
          </UseCaseCard>
        </UseCaseCards>
      </UseCasesSection>

      {/* CTA Section */}
      <CTASection>
        <CTABackground />
        <CTAContent>
          <CTATitle>
            정보 전달의 새로운 방식
            <br />
            Autodisplay로 완성!
          </CTATitle>
          <CTADescription>
            복잡한 개발 과정과 느린 업데이트는 이제 그만
            <br />
            AI가 모든 정보를 가장 빠르고 정확하며, 생동감 있는 웹 콘텐츠로
            자동화합니다.
          </CTADescription>
          <CTAButtons>
            <PrimaryButton onClick={() => navigate("/Login")}>
              바로 시작하기
            </PrimaryButton>
            {/* <SecondaryButton>
                            비즈니스 문의하기
                        </SecondaryButton> */}
          </CTAButtons>
        </CTAContent>
      </CTASection>

      {/* Footer Section */}
      <FooterSection>
        <FooterContent>
          <ServiceName>AutoDisplay</ServiceName>
          <CompanyInfo>
            <CompanyInfoText>
              사업자 등록번호: 678 - 81 - 01795 | 대표자: 박영수
            </CompanyInfoText>
            <CompanyInfoText>대표전화: 031 - 216 - 5930</CompanyInfoText>
            <CompanyInfoText>
              통신판매업신고: 제 2025 - 경기안산 - 0424호
            </CompanyInfoText>
            <CompanyInfoText>
              고객센터 운영시간: 10:00 ~ 18:00 | 메일: info@userconnect.kr
            </CompanyInfoText>
            <CompanyInfoText>
              주소: 경기도 안산시 상록구 해양3로 15,
              <br />
              1512호 ~ 1515호 (그랑시티 시그니처타워)
            </CompanyInfoText>
            <CompanyName>(주) 유저커넥트</CompanyName>
          </CompanyInfo>
        </FooterContent>
        <Copyright>
          <CopyrightText>
            Copyright © 2025 Userconnect Co, Inc All rights reserved.
          </CopyrightText>
        </Copyright>
      </FooterSection>
    </MobileContainer>
  );
};

export default PageAutodisplayMobileLanding;
